import { SANDBOX_MODE } from '../../lib/defaults';
import {
    getCheckoutParentPlans,
    getLegacyParentPlans,
} from '../../lib/parent-plan-catalog.js';

/* eslint-disable camelcase */
export const StripePlans = getLegacyParentPlans();
export const StripePlansNew = getCheckoutParentPlans();

export const StripeStudents = [
    {
        id: '50 students',
        name: 'Up to 50	students',
        recurring: true,
        plans: [
            {
                id: 'monthly',
                name: '1 Month',
                name_planButton: '1 Month',
                amount: '$10.99',
                duration: 'for a monthly subscription',
                recurring: true,
                savings: 'START NOW',
                notice_text: 'for a 1-month Muzology subscription.',
                notice_text2: 'Easily cancel within a month, and you won’t be charged for the next subscription period.',
                priceId: SANDBOX_MODE ? 'price_1OtblRJCkvkbxYUrbcBUvdPZ' : 'price_1Oz31vJCkvkbxYUrDWVQc1Fa',
                paypalPlanID: SANDBOX_MODE ? 'P-63K14984Y73523415MYTTZSA' : 'P-1UG07954A2921821XMYTTVNY'
            },
            {
                id: '3month',
                name: '3 Months',
                name_planButton: '3 Months',
                amount: '$27.00',
                duration: 'for a 3 month subscription',
                recurring: true,
                savings: 'SAVE MORE!',
                notice_text: 'for a 3-month Muzology subscription.',
                notice_text2: 'Easily cancel within three months, and you won’t be charged for the next subscription period.',
                priceId: SANDBOX_MODE ? 'price_1OtboYJCkvkbxYUrYlPUJdv0' : 'price_1Oz31tJCkvkbxYUrvvMts6Oj',
                paypalPlanID: SANDBOX_MODE ? 'P-63K14984Y73523415MYTTZSA' : 'P-8RB797571S320122UMYTUHVQ'
            },
            {
                id: 'annual',
                name: '1 Year',
                name_planButton: '1 Year',
                amount: '$92.00',
                duration: 'for an annual subscription',
                recurring: true,
                savings: 'BEST VALUE',
                notice_text: 'for a 1-year Muzology subscription.',
                notice_text2: 'Easily cancel and you won’t be charged for the next annual subscription period.',
                priceId: SANDBOX_MODE ? 'price_1OtbpqJCkvkbxYUr3VJESWi9' : 'price_1Oz31rJCkvkbxYUrC0FZL8RV',
                paypalPlanID: SANDBOX_MODE ? 'P-63K14984Y73523415MYTTZSA' : 'P-57T890375M4548927MYTUF7Q'
            }
        ]
    },
    {
        id: '100 students',
        name: 'Up to 100	students',
        recurring: true,
        plans: [
            {
                id: 'monthly',
                name: '1 Month',
                name_planButton: '1 Month',
                amount: '$16.99',
                duration: 'for a monthly subscription',
                recurring: true,
                savings: 'START NOW',
                notice_text: 'for a 1-month Muzology subscription.',
                notice_text2: 'Easily cancel within a month, and you won’t be charged for the next subscription period.',
                priceId: SANDBOX_MODE ? 'price_1Otbr3JCkvkbxYUr90QiK1mV' : 'price_1Oz31pJCkvkbxYUr0MOm6XBC',
                paypalPlanID: SANDBOX_MODE ? 'P-63K14984Y73523415MYTTZSA' : 'P-4CD241596M7927907MYTTV3Q'
            },
            {
                id: '3month',
                name: '3 Months',
                name_planButton: '3 Months',
                amount: '$45.00',
                duration: 'for a 3 month subscription',
                recurring: true,
                savings: 'SAVE MORE!',
                notice_text: 'for a 3-month Muzology subscription.',
                notice_text2: 'Easily cancel within three months, and you won’t be charged for the next subscription period.',
                priceId: SANDBOX_MODE ? 'price_1OtbrfJCkvkbxYUr8IE5SrCy' : 'price_1Oz31oJCkvkbxYUr0y3oG1HY',
                paypalPlanID: SANDBOX_MODE ? 'P-63K14984Y73523415MYTTZSA' : 'P-8B393129P34584742MYTUH4I'
            },
            {
                id: 'annual',
                name: '1 Year',
                name_planButton: '1 Year',
                amount: '$157.00',
                duration: 'for an annual subscription',
                recurring: true,
                savings: 'BEST VALUE',
                notice_text: 'for a 1-year Muzology subscription.',
                notice_text2: 'Easily cancel and you won’t be charged for the next annual subscription period.',
                priceId: SANDBOX_MODE ? 'price_1OtbsCJCkvkbxYUrme71vLwC' : 'price_1Oz31mJCkvkbxYUrIcIVv86o',
                paypalPlanID: SANDBOX_MODE ? 'P-63K14984Y73523415MYTTZSA' : 'P-32E14694YU221724UMYTUGYA'
            }
        ]
    },
    {
        id: '200 students',
        name: 'Up to 200	students',
        recurring: true,
        plans: [
            {
                id: 'monthly',
                name: '1 Month',
                name_planButton: '1 Month',
                amount: '$21.99',
                duration: 'for a monthly subscription',
                recurring: true,
                savings: 'START NOW',
                notice_text: 'for a 1-month Muzology subscription.',
                notice_text2: 'Easily cancel within a month, and you won’t be charged for the next subscription period.',
                priceId: SANDBOX_MODE ? 'price_1OtbsnJCkvkbxYUrURnXTO86' : 'price_1Oz31kJCkvkbxYUrlOHaQ7pl',
                paypalPlanID: SANDBOX_MODE ? 'P-63K14984Y73523415MYTTZSA' : 'P-99E01687AV363645XMYTTWMQ'
            },
            {
                id: '3month',
                name: '3 Months',
                name_planButton: '3 Months',
                amount: '$60',
                duration: 'for a 3 month subscription',
                recurring: true,
                savings: 'SAVE MORE!',
                notice_text: 'for a 3-month Muzology subscription.',
                notice_text2: 'Easily cancel within three months, and you won’t be charged for the next subscription period.',
                priceId: SANDBOX_MODE ? 'price_1OtbtKJCkvkbxYUrhMYrd2Pz' : 'price_1Oz31jJCkvkbxYUr1hCuLiXX',
                paypalPlanID: SANDBOX_MODE ? 'P-63K14984Y73523415MYTTZSA' : 'P-4N2772622P209331AMYTUIDA'
            },
            {
                id: 'annual',
                name: '1 Year',
                name_planButton: '1 Year',
                amount: '$197',
                duration: 'for an annual subscription',
                recurring: true,
                savings: 'GREAT VALUE',
                notice_text: 'for a 1-year Muzology subscription.',
                notice_text2: 'Easily cancel and you won’t be charged for the next annual subscription period.',
                priceId: SANDBOX_MODE ? 'price_1OtbtkJCkvkbxYUrYFpxSEo8' : 'price_1Oz31dJCkvkbxYUrLAzan8ij',
                paypalPlanID: SANDBOX_MODE ? 'P-63K14984Y73523415MYTTZSA' : 'P-0RT79336L83066146MYTUG7A'
            }
        ]
    }
];
